import { PlanCard } from "./PlanCard";

interface PlansGridProps {
  plans: any[];
  onViewRoutines: (planId: string) => void;
  onUnsubscribe?: (planId: string) => void;
  isUnsubscribing?: boolean;
}

export const PlansGrid = ({ 
  plans, 
  onViewRoutines, 
  onUnsubscribe,
  isUnsubscribing 
}: PlansGridProps) => {
  if (!plans || plans.length === 0) {
    return (
      <div className="text-center text-white/60 py-8">
        No tienes planes de entrenamiento personales o suscritos
      </div>
    );
  }

  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      {plans.map((plan) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          onViewRoutines={onViewRoutines}
          onUnsubscribe={onUnsubscribe}
          isUnsubscribing={isUnsubscribing}
        />
      ))}
    </div>
  );
};